// extracted by mini-css-extract-plugin
module.exports = {"def":"_type_def__swHtP","dense":"_type_dense__3Sxx-","slide-fwd-right":"_type_slide-fwd-right__2Na3H"};